/**
 * 메시지 파이프라인
 *
 * SDK v1.2.0 변경사항:
 * - 암호화/복호화는 SDK send() 메서드가 내부적으로 처리합니다.
 * - processRequest()와 processResponse()는 SecurePlayground 데모용으로만 유지됩니다.
 * - 실제 채팅에서는 SDK send()를 직접 사용하세요.
 */

import { encryptMessage, decryptMessage } from './encrypt'
import { filterMessage } from './filter'
import { maskMessage } from './mask'
import { removeExtraInfo } from './parseMessage'

/**
 * 요청 파이프라인 (SecurePlayground 데모용)
 * SDK v1.2.0: 실제 채팅에서는 이 함수를 사용하지 않습니다.
 * SDK send()가 내부적으로 암호화를 처리합니다.
 */
export async function processRequest({ content, sdk }) {
  const encrypted = await encryptMessage(content, sdk);
  return { encrypted };
}

/**
 * 응답 파이프라인 (SecurePlayground 데모용)
 * SDK v1.2.0: 실제 채팅에서는 이 함수를 사용하지 않습니다.
 * SDK가 응답을 자동으로 복호화합니다.
 */
export async function processResponse({ content, sdk, encrypted }) {
  let result = content;
  // 1. 복호화 (필요시) - SecurePlayground 데모용
  if (encrypted) {
    result = await decryptMessage(content, sdk);
  }
  // 2. 필터링
  const filterRes = await filterMessage(result);
  // 3. 마스킹
  const maskRes = await maskMessage(filterRes.filtered);
  // 4. 부가 정보 제거
  let displayContent = removeExtraInfo(maskRes.masked);
  return {
    ...filterRes,
    ...maskRes,
    displayContent
  };
}
